<template>
  <div>
    <LayerMeasureArea v-if="currentTool === 'areameasurement'" />
    <LayerMeasureLine v-if="currentTool === 'linemeasurement'" ref="LayerMeasureLine" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { LayerMeasureLine, LayerMeasureArea } from './index'

export default {
  name: 'MeasureLayers',
  components: {
    LayerMeasureLine,
    LayerMeasureArea
  },
  computed: {
    ...mapState({
      currentTool: (state) => state.currentTool
    }),
    ...mapGetters({
      isMeasurementActive: 'isMeasurementActive'
    })
  },
  created() {
    this.$store.map.on('click', this.onClick)
    this.$store.map.on('mousemove', this.onMouseMove)
  },
  beforeUnmount() {
    this.$store.map.off('click', this.onClick)
    this.$store.map.off('mousemove', this.onMouseMove)
  },
  methods: {
    onClick(event) {
      if (this.isMeasurementActive && this.currentTool === 'linemeasurement') {
        this.$refs.LayerMeasureLine.handleClick(event)
      }
    },
    onMouseMove(event) {
      if (this.isMeasurementActive && this.currentTool === 'linemeasurement') {
        this.$refs.LayerMeasureLine.handleMousemove(event)
      }
    }
  }
}
</script>
